<template>
    <div>
        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>纠纷列表</b></p>


        </div>

        <el-table :data="disputesList" style="width: 100%" @select="selectClick" @row-click="rowClick"
            ref="productTable" highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>
            <el-table-column type="index" width="40">
            </el-table-column>


            <el-table-column prop="bigName" label="刺头" min-width="9%">
            </el-table-column>

            <el-table-column prop="identityCard" label="身份证号" min-width="16%">
            </el-table-column>

            <el-table-column prop="disputesImage" label="纠纷证明" min-width="10%">
                <template slot-scope="scope">
                    <el-image :src="'https://' + imagePath + scope.row.disputesImage"
                        v-if="scope.row.disputesImage == '' ? false : true"></el-image>
                </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="15%">
            </el-table-column>

            <el-table-column prop="statusDes" label="状态" min-width="5%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="145">

                <template slot-scope="scope">

                    <el-button @click="checkOrNoClick(scope.row)" type="success" size="small">{{
            scope.row.statusDes == '未审' ? '审核' : '反审'
        }}</el-button>

                    <!-- <el-button @click="deleteClick(scope.row)" type="danger" round size="small"
                        v-if="scope.row.statusStr == '待审' || scope.row.statusStr == '已审'">
                        删除
                    </el-button> -->

                </template>
            </el-table-column>

        </el-table>

    </div>
</template>

<script>
export default {
    name: "TenantAdmin",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            imagePath: this.getImagePath(),

            disputesList: [],
            dlgFormVisible: false,

            opCompanyId: '',

            form: {
                id: '',
                companyName: '大公司',
                username: '老板',
                phone: '18888888888',

                createdTime: new Date(),
                expireTime: '',
                status: 0,
                queryCount: 0
            },

            formLabelWidth: '120px',

            rules: {
                expireTime: [
                    { required: true, message: '请选择有效期', trigger: 'blur' },
                    { required: true, message: '请选择有效期', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        checkOrNoClick(row) {

            this.$confirm('确定执行此操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.checkDisputes(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })

        },
        checkDisputes(row) {
            this.$axios({
                method: "post",
                url: "/shiro/disputes/check",
                data: {
                    id: row.id,
                    status: row.status == 0 ? 1 : 0
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.getAll()
            })
        },
        selectClick(selection, row) {
            this.rowClick(row)
        },
        rowClick(row) {

            this.$refs.productTable.clearSelection()
            this.$refs.productTable.toggleRowSelection(row)

            this.opCompanyId = row.id
        },
        deleteClick(row) {
            this.$confirm('确定要删除该租户吗？可能造成无法挽回的损失！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeCompany(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                })
            })
        },
        getAll() {

            this.$axios({
                method: "post",
                url: "/shiro/disputes/all/admin",
                data: {

                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.disputesList = data.data

                if (this.disputesList.length > 0) {

                    this.total = this.disputesList[0].total
                }

                for (let i in this.disputesList) {

                    if (this.disputesList[i].status == 0) {

                        this.disputesList[i].statusDes = '未审'

                    } else if (this.disputesList[i].status == 1) {

                        this.disputesList[i].statusDes = '已审'
                    }
                }

            })
        },
    },
    mounted() {

        this.getAll()
    }
}
</script>

<style>
#order-header {
    height: 70px;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}
</style>